import type { ArticleModuleHeroSidebarSectionCopyrightFragment } from '#components/Article/Modules/__generated__/ArticleModuleHeroSidebarSectionCopyright.generated';

export function getCopyrightInformation(data: ArticleModuleHeroSidebarSectionCopyrightFragment) {
	return {
		copyright: data?.copyright || null,
		text: data?.title || null,
		thumbnailCopyright: data?.thumbnail?.copyright || null,
		thumbnailText: data?.thumbnail?.title || null,
	};
}
